var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eula-modal"},[_c('ion-content',{staticClass:"ion-padding"},[_c('iframe',{staticStyle:{"overflow":"hidden"},attrs:{"src":_vm.externalUrl,"width":"100%","height":"100%","frameborder":"0"},on:{"load":_vm.iframeLoaded}})]),_c('ion-button',{attrs:{"expand":"full"},on:{"click":_vm.signAgreement}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }